// Drop-in replacement for sensei-app/client/ui/StudentDashboard.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class StudentDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-student-dashboard`,
            disableCustomizations: true,
            resizableWidgets: true, 
        });
        await super.initialize();
    }
    
    async initAfterLogin() {
        if(this.dashboardComponent){
            const predefinedLayout = [
                // Row 1: Quick actions and recent grades
                { name: 'NextActivityWidget', widgetId: 'studentNextActivity', rows: 10, cols: 10 },
                { name: 'RecentGradesWidget', widgetId: 'studentRecentGrades', rows: 10, cols: 10 },
                { name: 'NotesShortcutWidget', widgetId: 'studentNotesShortcut', rows: 10, cols: 10 },
                
                { name: 'WeeklyActivityWidget', widgetId: 'studentWeeklyActivity', rows: 12, cols: 15 },
                { name: 'ActivityTypeDistributionWidget', widgetId: 'studentActivityDistribution', rows: 12, cols: 15 },
                // Row 2: Overviews of progress and outstanding items
                { name: 'CourseProgressWidget', widgetId: 'studentCourseProgress', rows: 12, cols: 15 },
                { name: 'OverdueActivitiesWidget', widgetId: 'studentOverdueActivities', rows: 12, cols: 15 },

                // Row 3: Visual representation of weekly effort
            ];
            await this.dashboardComponent.setDashboardLayout(predefinedLayout);
        }
    }

    async render() {
        // The container is already set up in initialize, so render just returns it.
        return this.dashboardComponent.render();
    }

    destroy() {
        // No need to destroy this.dashboardComponent here, as ComponentBase handles
        // destroying all managed components.
        super.destroy();
    }
}